module.exports = __webpack_public_path__ + "img/Dispose-disabled.c23a8807.svg";